import { useNavigate, useSearchParams } from "react-router-dom";
import SimpleButton from "../Input/SimpleButton";
import { BrandName } from "./BrandName";
import { trackButtonClick } from "../../Analytics/googleAnalytics";

export function WebNavBar({ children }: { children?: React.ReactNode }) {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	const handleSignupClick = () => {
		trackButtonClick("Signup", "Sign Up", "navbar");
		const queryString = searchParams.toString();
		const currentHash = window.location.hash;
		navigate(`/landing${queryString ? `?${queryString}` : ""}#pricing`);
		if (currentHash === "#pricing") {
			document
				.getElementById("pricing")
				?.scrollIntoView({ behavior: "smooth" });
		}
	};

	const handleLoginClick = () => {
		trackButtonClick("Login", "Login", "navbar");
		navigate("/login");
	};

	return (
		<nav>
			<div className="flex justify-between items-center">
				<BrandName theme="dark" navigateTo="/landing" />
				<div className="flex flex-nowrap gap-2 sm:gap-4">
					<SimpleButton
						onClick={handleSignupClick}
						className="h-8 bg-primary-active text-primary-background rounded-full px-3 sm:px-4 text-sm sm:text-base whitespace-nowrap"
					>
						<p>Sign Up</p>
					</SimpleButton>
					<SimpleButton
						onClick={handleLoginClick}
						className="h-8 border-primary-accent hover:border-primary-active active:border-primary-active border text-primary rounded-full px-3 sm:px-4 text-sm sm:text-base whitespace-nowrap"
					>
						<p>Login</p>
					</SimpleButton>
				</div>
			</div>
		</nav>
	);
}
